import { useEffect, useState } from "react";

// Tracks the on-screen keyboard through visualViewport: sets --kb (px hidden by it) and html.kb-open.
const vv = typeof window !== "undefined" ? window.visualViewport : null;
const subs = new Set();
let open = false;

const update = () => {
  if (!vv) return;
  const hidden = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
  const typing = document.activeElement?.matches?.("input:not([type=checkbox]):not([type=radio]), textarea, select, [contenteditable=true]");
  const next = hidden > 120 && !!typing;
  document.documentElement.style.setProperty("--kb", `${next ? hidden : 0}px`);
  if (next !== open) {
    open = next;
    document.documentElement.classList.toggle("kb-open", open);
    subs.forEach((f) => f(open));
  }
  if (open) {
    const form = document.activeElement.closest("form");
    const submit = form?.querySelector("[type=submit]");
    if (submit) setTimeout(() => submit.scrollIntoView({ block: "nearest", behavior: "smooth" }), 60);
  }
};

export const watchViewport = () => {
  if (!vv) return;
  vv.addEventListener("resize", update);
  document.addEventListener("focusin", () => setTimeout(update, 300));
  document.addEventListener("focusout", () => setTimeout(update, 100));
};

export const useKeyboardOpen = () => {
  const [v, setV] = useState(open);
  useEffect(() => { subs.add(setV); return () => subs.delete(setV); }, []);
  return v;
};
